export default {
  main: {
    preview: [
      {
        href: 'overview',
        icon: 'dashboard',
        text: '总览',
      }, {
        href: 'bill',
        icon: 'report',
        text: '账单',
      }, {
        href: 'data_statistics',
        icon: 'data_manage',
        text: '数据统计'
      }, {
        href: 'bypass-account',
        icon: 'statistics',
        text: '子账户'
      }, {
        href: 'organization',
        icon: 'statistics',
        text: '机构管理'
      }, {
        href: 'baseline',
        icon: 'statistics',
        text: '基线管理'
      }, {
        href: 'template',
        icon: 'statistics',
        text: '模版管理'
      }
    ],
  },
  research: {
    pgs: [
      {
        href: 'data_manage',
        icon: 'data_manage',
        text: '数据统计',
      }, {
        href: 'statistics',
        icon: 'statistics',
        text: '统计'
      }
    ],
    pgd: [
      {
        href: 'statistics',
        icon: 'statistics',
        text: '统计'
      }
    ],
    azf: [
      {
        href: 'data_manage',
        icon: 'data_manage',
        text: '类型编辑',
      },
      {
        href: 'statistics',
        icon: 'statistics',
        text: '统计'
      }
    ],
    'array-pgt': [
      {
        href: 'statistics',
        icon: 'statistics',
        text: '统计'
      }
    ]
  },
  sub: {
    pgs: [
      {
        href: "overview",
        icon: "dashboard",
        text: "总览",
      }, {
        href: "report",
        icon: "report",
        text: "报告列表",
      }, {
        href: "data_manage",
        icon: "data_manage",
        text: "数据管理",
      }, {
        href: "statistics",
        icon: "statistics",
        text: "统计",
      }, {
        href: "data_statistics",
        icon: "statistics",
        text: "数据回顾",
      }, {
        href: "recycle_bin",
        icon: "recycle_bin",
        text: "回收站",
      }
    ],
    pgd: [
      {
        href: "overview",
        icon: "dashboard",
        text: "总览",
      }, {
        href: "report",
        icon: "report",
        text: "报告列表",
      }, {
        href: "data_manage",
        icon: "data_manage",
        text: "数据管理",
      }, {
        href: "statistics",
        icon: "statistics",
        text: "统计"
      }, {
        href: "recycle_bin",
        icon: "recycle_bin",
        text: "回收站",
      }
    ],
    azf: [
      {
        href: "overview",
        icon: "dashboard",
        text: "总览",
      }, {
        href: "report",
        icon: "report",
        text: "报告列表",
      }, {
        href: "data_manage",
        icon: "data_manage",
        text: "数据管理",
      }, {
        href: "statistics",
        icon: "statistics",
        text: "统计",
      }, {
        href: "recycle_bin",
        icon: "recycle_bin",
        text: "回收站",
      }
    ],
    ecs: [
      {
        href: "overview",
        icon: "dashboard",
        text: "总览",
      }, {
        href: "report",
        icon: "report",
        text: "报告列表",
      }, {
        href: "data_manage",
        icon: "data_manage",
        text: "数据管理",
      }, {
        href: "recycle_bin",
        icon: "recycle_bin",
        text: "回收站",
      }
    ],
    'array-pgt': [
      {
        href: "overview",
        icon: "dashboard",
        text: "总览",
      }, {
        href: "report",
        icon: "report",
        text: "报告列表",
      }, {
        href: "data_manage",
        icon: "data_manage",
        text: "数据管理",
      },
      {
        href: "statistics",
        icon: "statistics",
        text: "统计"
      },
      {
        href: "recycle_bin",
        icon: "recycle_bin",
        text: "回收站",
      }
    ]
  }

}



// WEBPACK FOOTER //
// ./src/app/api/navData.js